<template>
  <div>
    <div v-if="items.length" class="items" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
         infinite-scroll-distance="1000">
      <template v-for="item in items" >
        <ItemsItem  v-bind="item" :key="item.id" v-if="item.hasOwnProperty('id')"></ItemsItem>
      </template>
    </div>
    <div class="description" v-else>
      お気に入りは登録されていません
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ItemsItem from './items/Item';
  export default {
    name: 'Favorite',
    components: {ItemsItem},
    data () {
      return {
        pageCode: 'favorite',
        busy: false,
        items: [],
        item_next_page_url: 'http://admin.harigu.com/api/items?page=1&ids=' + localStorage.getItem('favorites')
      };
    },
    computed: {
      loading () {
        return this.$store.state.loading;
      }
    },
    methods: {
      async fetch () {
        if (this.busy) return;
        if (!this.item_next_page_url) return;
        this.busy = true;
        this.$store.commit('setLoading');
        let response = await axios.get(this.item_next_page_url);
        if (response.data && response.data.items && response.data.items.data.length) {
          this.items = this.items.concat(response.data.items.data);
        }
        this.item_next_page_url = response.data.next_page_url;
        this.$store.commit('resetLoading');
        this.busy = false;
      },
      loadMore: function () {
        setTimeout(() => {
          this.fetch();
        }, 1000);
      }
    },
    created () {
      this.fetch();
    }
  };
</script>

<style scoped lang="scss">
  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .description {
    text-align: center;
    padding: 4rem 1rem;
  }
</style>
